﻿import { formatPrice, initSimpleBar, processMarkedForRemove, replaceContentSmooth, windowMedia } from "../../helpers";
import { productComparerProdArtDto } from "../../models/productcomparer/productComparerProdArtDto";
import { productComparerSwapProdArtDto } from "../../models/productcomparer/productComparerSwapProdArtDto";
import { getTranslations } from "../../translations";
import { getUserApiAuthorize } from "../../utilities/api.userauth";
import { Popup } from "../../utilities/popup";
import { FavoritePopup, setFavoritePopup } from "../../widget/favorites/favorites.popup";
import { sendDataLayer } from "../ecommerce/ecommerce";
import { Tooltip, TooltipOptions, TooltipTrigger, TooltipType } from "../tooltip/tooltip";
import { ProductComparer } from "./productcomparer";

document.addEventListener("DOMContentLoaded", function ()
{
    const comparer = new ProductComparer(false);
    if ($("#productcomparerpage").length > 0)
    {
        const comparerPage = new ProductComparerPage(comparer, { skipRetrievingProdArt: false, toggleDiff: false, articles: null });
    }
});

class ProductCompareOptions
{
    toggleDiff: boolean;

    skipRetrievingProdArt: boolean;

    articles?: Array<productComparerProdArtDto> | null;
}

export class ProductComparerPage
{
    comparer: ProductComparer;
    showDifference: boolean;
    options: ProductCompareOptions;
    prodCompShowDiff: boolean;
    artOuterWrapHeight: number;
    artOuterWrapStickyHeight: number;
    lastOffset: number;

    prodCompScrollIntervalLocked: boolean = false;
    prodCompScrollIntervalTime: number = 0;
    prodCompOffsetIntervalMax: number = 700;
    stickyObserver = null;

    container: HTMLElement;
    btnLeft: HTMLButtonElement;
    btnRight: HTMLButtonElement;
    itemWidth: number;

    constructor(comparer: ProductComparer, options?: ProductCompareOptions)
    {
        this.comparer = comparer;
        this.options = options;

        this.initProductPage();
    }

    private initProductPage()
    {
        const instance = this;

        this.initProductComparePage(false, false, false);
    }

    private initEvents = () =>
    {
        const instance = this;

        if ($(".js-comparer-show-diff").length > 0)
        {
            $(".js-comparer-show-diff").off("change");
            $(".js-comparer-show-diff").on("change", function ()
            {
                instance.initProductComparePage(true, true, false);
            });
        }

        this.container = $(".prodcomp-content")[0] as HTMLDivElement;
        this.btnLeft = document.getElementById("btn-left") as HTMLButtonElement;
        this.btnRight = document.getElementById("btn-right") as HTMLButtonElement;
        this.itemWidth = this.container.querySelector(".prodcomp-article-item")!.clientWidth + 20; // Add margin

        if (instance.container)
        {
            instance.btnLeft.addEventListener("click", instance.scrollLeft);
            instance.btnRight.addEventListener("click", instance.scrollRight);

            const resizeObserver = new ResizeObserver(() =>
            {
                instance.updateButtons();
            });

            resizeObserver.observe(instance.container);
        }

        instance.updateButtons();
    }

    private getItemWidth = (): number =>
    {
        const item = this.container.querySelector(".prodcomp-article-item") as HTMLElement;
        return item ? item.clientWidth : 0;
    }

    private scrollLeft = () =>
    {
        this.container.scrollBy({ left: -this.getItemWidth(), behavior: "smooth" });

        setTimeout(this.updateButtons, 300);
    }

    private scrollRight = () =>
    {
        this.container.scrollBy({ left: this.getItemWidth(), behavior: "smooth" });
        setTimeout(this.updateButtons, 300);
    }

    private updateButtons = () =>
    {
        const canScroll = this.container.scrollWidth > this.container.clientWidth;

        // show/ hide
        this.btnLeft.style.display = canScroll ? "flex" : "none";
        this.btnRight.style.display = canScroll ? "flex" : "none";

        if (!canScroll) return;

        // disable
        this.btnLeft.disabled = this.container.scrollLeft <= 0;
        this.btnRight.disabled = this.container.scrollLeft + this.container.clientWidth >= this.container.scrollWidth;
    }

    private getReturnUrl(): string
    {
        var returnUrl = "/";

        // Check if referrer exists and is of same domain.
        if (document.referrer &&
            document.referrer.length > 0 &&
            document.referrer.indexOf(location.protocol + "//" + location.host) === 0
        )
            returnUrl = document.referrer;

        return returnUrl;
    }

    private initProductComparePage(toggleDiff, skipRetrievingProdArt, showPopupProdArt)
    {
        const comparerPage = this;

        if (toggleDiff)
        {
            this.prodCompShowDiff = !this.prodCompShowDiff;

            $("#prodcomp-show-diff").prop("checked", this.prodCompShowDiff);

            sendDataLayer({
                "category": "productcomparer",
                "action": "Product compare show differences only",
                "label": this.prodCompShowDiff ? "Yes" : "No",
                "url": window.location.pathname,
                "event": "Click"
            });
        }
        else
        {
            sendDataLayer({
                "category": "productcomparer",
                "action": "(Re)load page",
                "url": window.location.pathname,
                "event": "Click"
            });
        }
        const page = this;
        var functionToHandle = {
            functionName: "getProductComparerArticlesForPage",
            parameters: [this.prodCompShowDiff, toggleDiff, null, false, showPopupProdArt],
            handleFunction: function ()
            {
                return page.getProductComparerArticlesForPage(this.parameters[0], this.parameters[1], this.parameters[2], this.parameters[3], this.parameters[4]);
            }
        };

        if (!skipRetrievingProdArt)
            // Get up-to-date data (from DB if logged in, otherwise from localstorage).
            this.comparer.loadProductComparerArticles(functionToHandle, false);
        else
            functionToHandle.handleFunction();
    }

    private getProductComparerArticlesForPage(showDifferenceOnly, showDifferenceToggled, productArticlesOverride, reloadArticles, showPopupProdArt)
    {
        const comparerPage = this;
        var functionToHandle = {
            functionName: null,
            parameters: null,
            handleFunction: function ()
            {
                var productArticles = [];

                if (productArticlesOverride)
                    productArticles = productArticlesOverride;
                else
                    productArticles = comparerPage.comparer.getCompareProdArts();

                if (!productArticles ||
                    productArticles.length == 0
                )
                    comparerPage.loadProductComparePageEmpty();
                else
                    return comparerPage.comparer.getProductComparerArticles(comparerPage, showDifferenceOnly, showDifferenceToggled, productArticles, comparerPage.loadProductComparePageData, showPopupProdArt);
            }
        };

        if (reloadArticles &&
            getUserApiAuthorize()
        )
            this.comparer.loadProductComparerArticles(functionToHandle, true);
        else
            functionToHandle.handleFunction();
    }

    // #region Load product template

    private loadProductComparePageEmpty()
    {
        $("#productcomparerpage").html(prodCompPageContentEmpty.replace("{returnUrl}", this.getReturnUrl()));

        const comparerPage = this;
        $.ajax({
            method: 'GET',
            url: '/services/modules/webshop.asmx/LoadTopProductsContent',
            success: function (topProducts)
            {
                //$("#film_roll").append(topProducts);
                //comparerPage.initializeTopProducts();
            }
        });
    }

    private loadProductComparePageData(comparerPage, articleData, showDifferenceToggled, showPopupProdArt)
    {
        // Set interval at the start to ensure enough time passes for the CSS slide animation.
        var startTime = 0;
        var startTimeInterval = 1;
        var startTimeMax = 0;
        var startInterval = null;

        // Use setInterval to ensure API result does not replace current content before a certain amount of ms has passed.
        // (This is so the CSS animation from the "only show differences" button can complete first.)
        if (showDifferenceToggled)
        {
            startTimeInterval = 20;
            startTimeMax = 400;

            startInterval = setInterval(function ()
            {
                startTime += startTimeInterval;

                if (startTime >= startTimeMax)
                    clearInterval(startInterval);
            }, startTimeInterval);
        }

        var articleRemoveAllContent = "";
        var articleContent = "";
        var propertyContent = "";
        var bottomButtonContent = "";

        var propertyItems = [];
        var compareProperties = articleData.articleProperties;

        // Format properties (like grouping property option names together).
        var propertyPriceItemContent = "";
        var propertyColorItemContent = "";
        var propertyItemContent = "";

        $(compareProperties).each(function (propIndex, propItem)
        {
            var propertyDropdownData = $(articleData.articles[0].propertyDropdowns)[0];

            // Only add to compare properties if not present for dropdown.
            if (!propertyDropdownData ||
                Object.keys(propertyDropdownData).filter(x => x == propItem.propertyID).length <= 0)
            {
                propertyItems.push({
                    propertyID: propItem.propertyID,
                    propertyName: propItem.name,
                    propertyInfo: propItem.info,
                    articleProperties: []
                });
            }
        });

        var showColourBlocks = false;

        $(articleData.articles).each(function (index, item)
        {
            var colorBlocksContent = "";
            var stickerButtonContent = "";
            var buttonHolderContent = "";
            var buttonHolderItemContent = "";

            if (item.colorBlocks &&
                item.colorBlocks.length > 0)
            {
                $(item.colorBlocks).each(function (colorIndex, colorItem)
                {
                    colorBlocksContent += prodCompPageContentArticleColorItem
                        .replaceAll("{colorcode}", colorItem.colorCode ?? "transparent")
                        .replaceAll("{colorcode1}", colorItem.colorCode1 ?? "transparent")
                        .replaceAll("{colorcode2}", colorItem.colorCode2 ?? "transparent")
                        .replaceAll("{colorname}", colorItem.colorName)
                        .replaceAll("{coloricon}", colorItem.colorLogo ?? "none");
                });
            }

            // #region Article button

            // Load article button if present.
            if (item.button)
            {
                var buttonLine1Content = "";
                var buttonLine2Content = "";

                if (item.button.line1Text)
                {
                    buttonLine1Content = prodCompPageContentArticleStickerButtonLine
                        .replaceAll("{lineclass}", item.button.line1Class)
                        .replaceAll("{linetext}", item.button.line1Text);
                }

                if (item.button.line2Text)
                {
                    buttonLine2Content = prodCompPageContentArticleStickerButtonLine
                        .replaceAll("{lineclass}", item.button.line2Class)
                        .replaceAll("{linetext}", item.button.line2Text);
                }

                if (buttonLine1Content.length > 0 ||
                    buttonLine2Content.length > 0)
                {
                    stickerButtonContent = prodCompPageContentArticleStickerButton
                        .replaceAll("{buttonclass}", item.button.buttonClass)
                        .replaceAll("{line1}", buttonLine1Content)
                        .replaceAll("{line2}", buttonLine2Content);
                }
            }

            // #endregion Article button

            var dropdownHolderContent = "";
            var changeMeasureContent = "";

            if (item.propertyDropdowns &&
                Object.keys(item.propertyDropdowns).length > 0)
            {
                $(Object.keys(item.propertyDropdowns)).each(function (dropdownIndex, dropdownKey: any)
                {
                    var dropdownItem = item.propertyDropdowns[dropdownKey];

                    if ($(dropdownItem).length > 0)
                    {
                        var dropdownHolderItemContent = "";
                        var measureSearchName = "";

                        $(dropdownItem).each(function (dropdownOptionIndex, dropdownOptionItem)
                        {
                            dropdownHolderItemContent += prodCompPageContentPropertyDropdownOptionItem
                                .replaceAll("{productid}", dropdownOptionItem.productID)
                                .replaceAll("{articleid}", dropdownOptionItem.articleID)
                                .replaceAll("{optionid}", dropdownOptionItem.optionDto.optionID)
                                .replaceAll("{optionname}", dropdownOptionItem.optionDto.optionName)
                                .replaceAll("{optionsearchname}", dropdownOptionItem.optionDto.optionSearchName)
                                .replaceAll("{selected}", dropdownOptionItem.selected ? "selected=\"selected\"" : "")
                                .replaceAll("{soldout}", dropdownOptionItem.soldout ? "soldout" : "");

                            // Check if measure.
                            if (dropdownOptionItem.optionDto.propertyID == 5 &&
                                dropdownOptionItem.selected
                            )
                                measureSearchName = dropdownOptionItem.optionDto.optionSearchName;
                        });

                        dropdownHolderContent += prodCompPageContentPropertyDropdownItem
                            .replaceAll("{productid}", item.productID)
                            .replaceAll("{articleid}", item.articleID)
                            .replaceAll("{propertyid}", dropdownItem[0].optionDto.propertyID)
                            .replaceAll("{options}", dropdownHolderItemContent);
                    }
                });
            }

            // Add buttons.
            if (item.soldout)
                buttonHolderItemContent += prodCompButtonUnavailable;
            else
                buttonHolderItemContent += prodCompButtonOrder;

            // Add button to bottom button holder.
            bottomButtonContent += prodCompButtonHolder
                .replaceAll(
                    "{buttoncontent}",
                    buttonHolderItemContent
                        .replaceAll("{productid}", item.productID)
                        .replaceAll("{articleid}", item.articleID)
                );

            buttonHolderItemContent = buttonHolderItemContent
                .replaceAll("{productid}", item.productID)
                .replaceAll("{articleid}", item.articleID)
                .replaceAll("{articlenumber}", item.articleNumber)


            // Add buttons to top button holder.
            buttonHolderContent = prodCompButtonHolder
                .replaceAll("{buttoncontent}", buttonHolderItemContent);

            // Set article content.
            articleContent += prodCompPageContentArticle
                .replaceAll("{articlestickerbutton}", stickerButtonContent)
                .replaceAll("{changemeasureholder}", changeMeasureContent)
                .replaceAll("{propertydropdowns}", dropdownHolderContent)
                .replaceAll("{favorite}", prodCompButtonFavourite)
                .replaceAll("{articlebuttonholder}", buttonHolderContent)
                .replaceAll("{favoritelistid}", item.favoriteListID)
                .replaceAll("{isfavoriteactive}", item.favorite != null && item.favorite ? "active" : "")
                .replaceAll("{productid}", item.productID)
                .replaceAll("{articleid}", item.articleID)
                .replaceAll("{articlenumber}", item.articleNumber)
                .replaceAll("{brand}", item.brand)
                .replaceAll("{name}", item.name)
                .replaceAll("{articleurl}", item.articleUrl)
                .replaceAll("{image}", item.articlePhoto)
                .replaceAll("{largeimage}", item.articlePhotoLarge)
                .replaceAll("{price}", item.price.toString().replace(".", ","))
                .replaceAll("{priceblock}", prodCompPageContentArticlePriceBlockItem
                    .replaceAll("{price}", item.price.toString().replace(".", ","))
                    .replaceAll("{oldprice}", (item.oldPrice || "").toString().replace(".", ","))
                    .replaceAll("{islowestprice}", item.lowestPrice ? "visible" : "hidden")
                )
                .replaceAll("{issoldout}", item.soldout ? "item-soldout" : "")
                .replaceAll("{colorpropertyblock}", prodCompPageContentArticleColorPropertyBlockItem
                    .replaceAll("{colorblocks}", colorBlocksContent)
                    .replaceAll("{hidecolorblocks}", item.colorBlocks.length > 0 ? "" : "hidden")
                    .replaceAll("{hidecolorexcess}", item.colorBlocksNotShown > 0 ? "" : "hidden")
                    .replaceAll("{colorexcesscount}", item.colorBlocksNotShown)
                );

            var activePropertyOptionValues = [];

            // #region Article active property values.

            if ($(item.properties).length > 0)
            {
                $(item.properties).each(function (propIndex, propItem)
                {
                    if (activePropertyOptionValues[propItem.propertyID])
                    {
                        activePropertyOptionValues[propItem.propertyID].optionName += ";" + propItem.optionName;
                        activePropertyOptionValues[propItem.propertyID].optionSearchName += ";" + propItem.optionSearchName;
                    }
                    else
                    {
                        activePropertyOptionValues[propItem.propertyID] = {
                            propertyID: propItem.propertyID,
                            optionName: propItem.optionName,
                            optionSearchName: propItem.optionSearchName
                        };
                    }
                });
            }

            if (Object.keys(item.propertyDropdowns).length > 0)
            {
                $(Object.keys(item.propertyDropdowns)).each(function (propIndex, propID: any)
                {
                    const selectedOption = item.propertyDropdowns[propID].filter(x => x.selected)[0];

                    if (selectedOption)
                    {
                        if (!activePropertyOptionValues[selectedOption.optionDto])
                        {
                            activePropertyOptionValues[selectedOption.optionDto.propertyID] = {
                                propertyID: selectedOption.optionDto.propertyID,
                                optionName: selectedOption.optionDto.optionName,
                                optionSearchName: selectedOption.optionDto.optionSearchName
                            };
                        }
                    }
                });
            }

            // #endregion Article active property values.

            // Filter empty indexes and get JQuery array.
            activePropertyOptionValues = $(activePropertyOptionValues.filter(x => { return x; })).toArray();

            // Add all property option values to the template (if their keys are present).
            if ($(activePropertyOptionValues).length > 0)
            {
                $($(activePropertyOptionValues)).each(function (index, item)
                {
                    articleContent = articleContent
                        .replaceAll(`{optionName${item.propertyID}}`, item.optionName)
                        .replaceAll(`{optionSearchName${item.propertyID}}`, item.optionSearchName);
                });
            }

            // Clean up any remaining option value template keys.
            articleContent = articleContent
                .replaceAll(/{optionName\d+}/g, "")
                .replaceAll(/{optionSearchName\d}/g, "");

            // Load property block content.
            $(compareProperties).each(function (propIndex, propertyItem)
            {
                var optionValue = "";

                var filteredProperties = item.properties.filter(x => x.propertyID == propertyItem.propertyID);

                if ($(filteredProperties).length > 0)
                {
                    // Check if property is allowed for current article.
                    if (typeof item.allowedProperties.find(x => x.propertyID == propertyItem.propertyID) !== typeof undefined)
                    {
                        var optionValues = [];
                        $(filteredProperties).each(function (artPropIndex, artPropItem)
                        {
                            if (artPropItem.optionName &&
                                artPropItem.optionName.length > 0
                            )
                                optionValues.push(artPropItem.optionName);
                        });

                        optionValues.sort();

                        if (optionValues.length > 0)
                            optionValue += optionValues.join("<br/>");
                    }

                    // Check if property was already added, and if so, add option value to it.
                    var propIndex = propertyItems.findIndex(x => x.propertyID == propertyItem.propertyID);

                    if (propIndex >= 0)
                    {
                        var propArtIndex = propertyItems[propIndex].articleProperties.findIndex(x => x.articleID == item.articleID);

                        // Add option for current property/article.
                        if (propArtIndex >= 0)
                            propertyItems[propIndex].articleProperties[propArtIndex].optionValue += "<br />" + optionValue;
                        // Push new article data for property.
                        else
                        {
                            propertyItems[propIndex].articleProperties.push({
                                articleID: item.articleID,
                                optionValue: optionValue
                            });
                        }
                    }
                    // Add new property with article data to array.
                    else
                    {
                        propertyItems.push({
                            propertyID: propertyItem.propertyID,
                            propertyName: propertyItem.name,
                            propertyInfo: propertyItem.info,
                            articleProperties: [
                                {
                                    articleID: item.articleID,
                                    optionValue: optionValue
                                }
                            ]
                        });
                    }
                }
            });



            propertyPriceItemContent += prodCompPageContentPropertyPriceOptionItem
                .replaceAll("{price}", formatPrice(item.price, true))
                .replaceAll("{oldprice}", formatPrice(item.oldPrice, false))
                .replaceAll("{newprice}", item.oldPrice ? "newprice" : "")
                .replaceAll("{islowestprice}", item.lowestPrice ? "visible" : "hidden");

            if (colorBlocksContent)
                showColourBlocks = true;

            propertyColorItemContent += prodCompPageContentPropertyColorOptionItem
                .replaceAll("{colorblocks}", colorBlocksContent)
                .replaceAll("{hidecolorblocks}", item.colorBlocks.length > 0 ? "" : "hidden")
                .replaceAll("{hidecolorexcess}", item.colorBlocksNotShown > 0 ? "" : "hidden")
                .replaceAll("{colorexcesscount}", item.colorBlocksNotShown);

            if (articleRemoveAllContent.length > 0)
                articleRemoveAllContent += ",";

            articleRemoveAllContent += `{productID: ${item.productID}, articleID: ${item.articleID}}`;
        });

        // Load all property options.
        $(propertyItems).each(function (propIndex, propItem)
        {
            // exclude (search) colour.
            if (propItem.propertyID != 3 &&
                propItem.propertyID != 4)
            {
                var propertyOptionContent = "";

                $(propItem.articleProperties).each(function (artPropIndex, artPropItem)
                {
                    propertyOptionContent += prodCompPageContentPropertyOptionItem
                        .replaceAll("{optionvalue}", artPropItem.optionValue);
                });

                propertyItemContent += prodCompPageContentPropertyItem
                    .replaceAll("{propertyid}", propItem.propertyID)
                    .replaceAll("{propertyname}", comparerPage.getPropertyTitleWithTooltip(propItem))
                    .replaceAll("{options}", propertyOptionContent);
            }
        });

        // Set property content.
        propertyContent += prodCompPageContentProperties
            .replaceAll("{priceoption}", prodCompPageContentPropertyPriceItem.replaceAll("{options}", propertyPriceItemContent))
            .replaceAll("{coloroption}", showColourBlocks
                ? prodCompPageContentPropertyColorItem.replaceAll("{options}", propertyColorItemContent)
                : ""
            )
            .replaceAll("{properties}", propertyItemContent);

        var modalContent = prodCompPageContentContent
            .replaceAll("{pagetitle}", prodCompPageContentTitle.replaceAll("{articlecount}", $(articleData.articles).length))
            .replaceAll("{removeallarticlesdata}", `[${articleRemoveAllContent}]`)
            .replaceAll("{articles}", articleContent)
            .replaceAll("{showdiff}", prodCompPageContentShowDiff.replaceAll("{showdiffchecked}", comparerPage.prodCompShowDiff ? "checked" : ""))
            .replaceAll("{properties}", propertyContent)
            .replaceAll("{bottombuttoncontent}", bottomButtonContent);

        var articleWrapperSticky = $(".prodcomp-article-outer-wrapper").hasClass("fixed");
        var articleWrapperStyle = $(".prodcomp-article-outer-wrapper").attr("style");
        var contentWrapperStyle = $(".prodcomp-content-wrapper").attr("style");
        var contentScrollLeft = $("#productcomparerpage .prodcomp-article-outer-wrapper").scrollLeft();
        var topOffset = $(window).scrollTop();

        if ($("#productcomparerpage").length > 0 &&
            $("#productcomparerpage").html().length > 0)
        {
            replaceContentSmooth("#productcomparerpage .prodcomp-top", $(modalContent).filter(".prodcomp-top")[0].innerHTML, true, 0);
            replaceContentSmooth("#productcomparerpage .prodcomp-content-wrapper", $(modalContent).filter(".prodcomp-content-wrapper")[0].innerHTML, true, $(".prodcomp-content-wrapper").width());
        }
        else 
        {
            $("#productcomparerpage").html(modalContent);
            comparerPage.initPropertyTooltip();
        }

        setTimeout(function ()
        {
            comparerPage.stickyHelper();
            initSimpleBar();
            comparerPage.initEvents();
        }, 1);

        setFavoritePopup(new FavoritePopup());
    }

    // #endregion Load product template

    // #region Helpers

    private stickyHelper()
    {
        try
        {
            if (!this.stickyObserver)
            {
                const trigger = document.getElementById('scrollTrigger');
                this.stickyObserver = new IntersectionObserver(
                    ([entry]) =>
                    {
                        if (!entry.isIntersecting)
                        {
                            $(".w-productcard-fixed").addClass('fixed');
                        } else
                        {
                            $(".w-productcard-fixed").removeClass('fixed');
                        }
                    },
                    { threshold: 0 }
                );
                this.stickyObserver.observe(trigger);
            }
        }
        catch (err)
        {
            console.error(err);
        }
    }

    private initPropertyTooltip()
    {
        const options = new TooltipOptions();
        options.trigger = TooltipTrigger.Click;
        options.type = TooltipType.Popup;

        new Tooltip(".tooltip", options);
    }

    private getPropertyTitleWithTooltip(item)
    {
        let title = item.propertyName;
        if (item.propertyInfo)
        {
            title += prodCompPageContentPropertyTooltip
                .replace("{infoText}", item.propertyInfo)
                .replaceAll("{propertyId}", item.propertyID);
        }
        return title;
    }

    // #endregion Helpers  
}

// #region Templates

// Page
const prodCompPageContentEmpty =
    `<div class="prodcomp-empty">
        <div class="prodcomp-wrapper-title">
            <h1 class="f-secondary-3xl">${getTranslations().comparePluralTitleText}</h1>
        </div>
        <div class="top-holder">
            <img src="${shopConfig().staticDomain}/images/smulders/box-empty.svg?v=20240212" alt="404" height="477" width="560" />
            <span class="f-secondary-l">${getTranslations().compareEmptyText}</span>
        </div>
    </div>`;

const prodCompPageContentContent =
    `<div class=\"prodcomp-top\">{pagetitle}</div>
        <div class=\"prodcomp-content-wrapper\">
              <div class="prodcomp-nav">
                <button id="btn-left" class="btn-arrow btn-arrow-left u-fixed-left"></button>
                <button id="btn-right" class="btn-arrow u-fixed-right"></button>
            </div>
            <div class=\"prodcomp-content\"> 
            <div class=\"prodcomp-article-outer-wrapper w-productcard-fixed\">    
                <div class=\"prodcomp-article-wrapper\">
                    <div class=\"prodcomp-article-wrapper--whitespace\"></div>
                    <div class=\"prodcomp-article-holder\">
                    {articles}
                    </div>
                </div>
            </div>
            <div id="scrollTrigger"></div>
            <div class=\"prodcomp-showdiff-wrapper u-checkbox-toggle\">{showdiff}</div>
            <div class=\"prodcomp-property-wrapper\">{properties}</div>            
        </div>
    </div>`;

const prodCompPageContentTitle =
    `<div class=\"prodcomp-wrapper-title\">
        <h1 class=\"f-secondary-3xl\">${getTranslations().comparePluralTitleText}</h1>
    </div>`;

const prodCompPageContentArticle =
    `<div class=\"prodcomp-article-item\">
        <div class=\"w-productcard__holder w-productcard__holder--pnone featureditem {issoldout}\" data-productid=\"{productid}\" data-articleid=\"{articleid}\" data-image=\"{image}\" data-largeimage=\"{largeimage}\" data-articlenumber=\"{articlenumber}\" data-name=\"{name}\" data-brand=\"{brand}\" data-prop94=\"{optionName94}\" data-prop8=\"{optionName8}\" data-prop5=\"{optionName5}\" data-price=\"{price}\">
            <article class="w-productcard br-2xl">
                <a class="w-productcard__image-holder o-2xl" href="{articleurl}" title="{name}" tabindex="-1" aria-hidden="true">
                   <img src=\"${shopConfig().staticDomain}{image}\" alt=\"{name}\" height=\"282\" width=\"282\" />
                </a>
                 <div class="w-productcard__content-holder">
                    <a class="w-productcard__content-link" href="{articleurl}" title="{name}" tabindex="-1" aria-hidden="true">
                        <span class="w-productcard__content-title">{name}</span>                        
                    </a>     
                    <div class="c-productcompare__product-block">
                        {articlestickerbutton}
     
                        {changemeasureholder}
                        {propertydropdowns}
                        {articlebuttonholder}    
                    </div>
                </div>     
                {favorite}
            </article>
        </div>
    </div>`;

const prodCompPageContentArticlePriceBlockItem = `<div class=\"prices\"><span class=\"before\">{oldprice}</span><span class=\"now\">{price}</span></div>`;

const prodCompPageContentArticleColorPropertyBlockItem = "<div class=\"available-colors-container {hidecolorblocks}\">{colorblocks}<span class=\"excessnumber {hidecolorexcess}\">+{colorexcesscount}</span></div>";

const prodCompPageContentArticleColorItem = "<div class=\"product-color\" style=\"background-image:{coloricon};\" title=\"{colorname}\"><span style=\"background-color:{colorcode1};\"></span><span style=\"background-color:{colorcode2};\"></span></div>";

const prodCompPageContentArticleStickerButton = "<div class=\"bullet {buttonclass}\"><div>{line1}{line2}</div></div>";

const prodCompPageContentArticleStickerButtonLine = "<span class=\"{lineclass}\">{linetext}</span>";

const prodCompButtonHolder = "<div class=\"prodcomp-buttons\">{buttoncontent}</div>";

const prodCompButtonOrder =
    `<a href=\"#\" class=\"btn btn-green btn-icon-cart\" onclick=\"addArticleToCart($(this), {articleid}, true, true, false, false, false, true); addArticleToCartAnimation($(this), '.featureditem[data-articleid={articleid}] .product-block img', true); pushProdCompArticleCart('{articlenumber}'); return false;\">${getTranslations().inCartText}</a>`;

const prodCompButtonFavourite =
    `<div class="w-productcard__favorite-block js-favorite-article {isfavoriteactive}" data-articleid="{articleid}" data-listid="{favoritelistid}">
        <div class="w-productcard__favorite-active btn-icon btn-icon-after ic-heart-full-aft"></div>
        <div class="w-productcard__favorite-inactive btn-icon btn-icon-after ic-heart-aft"></div>
    </div>`;


const prodCompButtonUnavailable = `<a href=\"#\" class=\"btn btn-lightgray btn-full-width btn-icon-left btn-icon-inline btn-icon-cart\" disabled>${getTranslations().buttonTextUnavailable}</a>`;

const prodCompPageContentShowDiff = `<label class="js-comparer-show-diff"><input type=\"checkbox\" id=\"prodcomp-show-diff\" {showdiffchecked}></input><span></span></label><span class=\"prodcomp-show-diff-text\">${getTranslations().onlyShowDifferenceText}</span>`;

const prodCompPageContentProperties = "<div class=\"prodcomp-property-holder\">{priceoption}{coloroption}{properties}</div>";

const prodCompPageContentPropertyPriceItem = `<div class=\"prodcomp-property\"><div class=\"prodcomp-property-header f-primary-s\">${getTranslations().txtPrice}</div>{options}</div>`;

const prodCompPageContentPropertyPriceOptionItem = `<div class=\"prodcomp-property-row prodcomp-property-row--price\"><span class=\"before\">{oldprice}</span><span class=\"now {newprice}\">{price}</span></div>`;

const prodCompPageContentPropertyColorItem = `<div class=\"prodcomp-property\" data-propertyid=\"3\"><div class=\"prodcomp-property-header f-primary-s\">${getTranslations().txtAvailableColors}</div>{options}</div>`;

const prodCompPageContentPropertyColorOptionItem = "<div class=\"prodcomp-property-row\"><div class=\"available-colors-container {hidecolorblocks}\">{colorblocks}<span class=\"excessnumber {hidecolorexcess}\">+{colorexcesscount}</span></div></div>";

const prodCompPageContentPropertyItem = "<div class=\"prodcomp-property\" data-propertyid=\"{propertyid}\"><div class=\"prodcomp-property-header f-primary-s\">{propertyname}</div>{options}</div>";

const prodCompPageContentPropertyOptionItem = "<div class=\"prodcomp-property-row f-primary-s\">{optionvalue}</div>";

const prodCompPageContentPropertyDropdownItem = "<div class=\"u-select-holder\"><select name=\"property{propertyid}\" onchange=\"swapComparerArticle(this, {productid}, {articleid}, false);\">{options}</select></div>";

const prodCompPageContentPropertyDropdownOptionItem = "<option class=\"{soldout}\" data-searchname=\"{optionsearchname}\" value=\"{productid}-{articleid}\" {selected}>{optionname}</option>";

const prodCompPageContentPropertyTooltip = `<a class="icon-info tooltip" data-tooltip-content="#tooltip_content_prop{propertyId}"></a><div class="tooltip_templates hidden"><span id="tooltip_content_prop{propertyId}">{infoText}</span></div>`;

// #endregion Templates